/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ClaimsInputs */

const en_nav_claims = /** @type {(inputs: Nav_ClaimsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claims`)
};

const fr_nav_claims = /** @type {(inputs: Nav_ClaimsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réclamations`)
};

/**
* | output |
* | --- |
* | "Claims" |
*
* @param {Nav_ClaimsInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const nav_claims = /** @type {((inputs?: Nav_ClaimsInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ClaimsInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_claims(inputs)
	return fr_nav_claims(inputs)
});